import { acceptInvite, inviteCoc, inviteSearch, rejectInvite } from '@/api/invite-friend'
import i18n from '@/i18n'
import { INVITE_STATUS } from '@/utils/constant'

function resetState() {
  return {
    user: null
  }
}

const state = resetState()

/** @type {import('vuex').MutationTree<typeof state>} */
const mutations = {
  resetState(state) {
    const initState = resetState()
    for (const key in initState) {
      state[key] = initState[key]
    }
  },
  setUser(state, user) {
    state.user = user
  }
}

/** @type {import('vuex').ActionTree<typeof state, rootState extends any>} */
const actions = {
  async inviteSearch({ commit }, params) {
    const data = await inviteSearch(params)
    if (!data.added) {
      commit('setUser', data.info)
      return data
    } else {
      throw new Error(i18n.tc('addressBook.NotAddFriendOfExist'))
    }
  },
  async inviteCoc(_, reqData) {
    const data = await inviteCoc(reqData)
    return data.inviteInfo
  },
  async acceptInviteFriend({ rootState, dispatch }, { inviteId, userId }) {
    await acceptInvite({ inviteId, uids: [rootState.userInfo.id] })
    // 修改通知中的消息
    dispatch('notification/updateManyNotify', {
      patchFunc(_notify) {
        return _notify.userId === userId && _notify.actType === INVITE_STATUS.RECEIVE
      },
      defPatchData: { actType: INVITE_STATUS.ACCEPT_YOU },
      limit: 1
    }, { root: true })

    dispatch('collaborator/getCompanyTree', null, { root: true })
  },
  async rejectInviteFriend({ dispatch }, { inviteId }) {
    await rejectInvite(inviteId)
    // 修改通知中的消息
    dispatch('notification/updateManyNotify', {
      patchFunc(_notify) {
        return _notify.inviteId === inviteId
      },
      defPatchData: { actType: INVITE_STATUS.REJECT_YOU },
      limit: 1
    }, { root: true })
    return null
  }
}

/** @type {import('vuex').Module} */
const inviteFriend = {
  namespaced: true,
  state,
  mutations,
  actions
}

export default inviteFriend
